import React from 'react';
import {useTranslation} from 'react-i18next';

export interface TableRule {
  name: string;
  minAmount: number;
  maxAmount: number;
  valueType: 'PERCENT_VALUE' | 'FIXED_VALUE';
  value: string;
}

interface RechargeTableProps {
  rules: TableRule[];
}

const RechargeTable: React.FC<RechargeTableProps> = ({rules}) => {
  const {t} = useTranslation();

  // 格式化奖励值
  const formatBonusValue = (valueType: string, value: string): string => {
    if (valueType === 'PERCENT_VALUE') {
      return `${value}%`;
    }
    return value;
  };

  if (!rules || rules.length === 0) {
    return (
      <div className="flex justify-center items-center py-8">
        <span className="text-gray-500 text-sm">
          {t('recharge.noRulesAvailable', 'No rules available')}
        </span>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* 表格容器 */}
      <div className="bg-[#E9ECF5] rounded-xl overflow-hidden border border-[#E9ECF5]">
        {/* 表头 */}
        <div className="grid grid-cols-2 bg-[#E9ECF5] border-b border-[#E9ECF5]">
          <div className="px-1 py-2 flex items-center justify-center">
            <span className="text-[#48505D] text-xs font-bold tracking-wide">
              {t('promotionsV2.rechargeAmount', 'Recharge Amount')}
            </span>
          </div>
          <div className="px-1 py-2 flex items-center justify-center">
            <span className="text-[#48505D] text-xs font-bold  tracking-wide">
              {t('promotionsV2.bonus', 'Bonus')}
            </span>
          </div>
        </div>

        {/* 表格数据行 */}
        {rules.map((rule, index) => (
          <div
            key={index}
            className={`grid grid-cols-2 ${
              index % 2 === 0 ? 'bg-white' : 'bg-[#F8F9FF]'
            }`}>
            {/* 充值金额列 */}
            <div className="px-1 py-2 flex items-center justify-center">
              <div className="flex items-center">
                <img
                  src={require('@/assets/imgs/recharge/coin.webp')}
                  alt="Coin"
                  className="w-4 h-4 mr-1 object-contain"
                />
                <span className="text-[#495057] text-xs font-bold">
                  ₹{rule.minAmount.toLocaleString()}~₹
                  {rule.maxAmount.toLocaleString()}
                </span>
              </div>
            </div>

            {/* 奖励列 */}
            <div className="px-1 py-2 flex items-center justify-center border-l border-[#E9ECF5]">
              <span className="text-[#495057] text-xs font-bold">
                {formatBonusValue(rule.valueType, rule.value)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RechargeTable;
